module.exports = __webpack_public_path__ + "static/media/TN-Men-Outer-v2.0.24e3f38a.svg";